"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _PortalSettingsKeys = require("crm_data/constants/PortalSettingsKeys");

var _SettingsActions = _interopRequireDefault(require("crm_internal/flux/settings/SettingsActions"));

var _hubspotFluxStores = _interopRequireDefault(require("hubspot.flux.stores.NavigationStore"));

var _OwnerIdsByEmailStore = _interopRequireDefault(require("crm_data/owners/OwnerIdsByEmailStore"));

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _loggers = require("customer-data-tracking/loggers");

var _handleStashInvitedUserSettings = function _handleStashInvitedUserSettings(inviteeEmail) {
  var _NavigationStore$get$ = _hubspotFluxStores.default.get().params,
      objectType = _NavigationStore$get$.objectType,
      subjectId = _NavigationStore$get$.subjectId;

  var curOwnerId = _CurrentOwnerContainer.default.get();

  if (objectType && subjectId && curOwnerId) {
    _SettingsActions.default.set(_PortalSettingsKeys.ATMENTION_USER_INVITE_MAP + ":" + inviteeEmail, JSON.stringify({
      objectType: objectType,
      objectId: subjectId,
      owner: curOwnerId
    }), true);
  }
};

var _default = {
  onShown: function onShown() {
    _loggers.CrmLogger.log('record-interaction', {
      action: '@mention invite shown'
    });
  },
  onInviteSuccess: function onInviteSuccess(inviteeEmail) {
    _handleStashInvitedUserSettings(inviteeEmail);

    _loggers.CrmLogger.log('record-interaction', {
      action: '@mention invite sent'
    });
  },
  onInviteFailure: function onInviteFailure() {
    _loggers.CrmLogger.log('record-interaction', {
      action: '@mention invite failed'
    });
  },
  validate: function validate(inviteeEmail) {
    // TODO this is going to create problems when Owners switches to a paged endpoint
    // This only works while LegacyOwnersStore exists
    if (_OwnerIdsByEmailStore.default.get(inviteeEmail)) {
      return _I18n.default.text('zeroStates.atMention.errors.existingUser');
    }

    return null;
  },
  provisioning: {
    send_welcome_email: true,
    subscriptions: [],
    roleGroups: [{
      type: 'sales',
      roles: ['user'],
      secondaryRoles: [{
        app: 'crmFeatures',
        type: 'enabled'
      }]
    }]
  }
};
exports.default = _default;
module.exports = exports.default;